import { ArrowForward } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Typography,
  useTheme,
} from "@mui/material";
import {
  BookmarkIcon,
  CompanyIcon,
  HourGlassIcon,
  PadlockIcon,
  PersonalIdIcon,
  SecurityIcon,
  TeamIcon,
} from "assets/styles/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppPrimaryButton } from "shared/components/AppComponents";
import Utils from "shared/helpers/Utils";

const RNDWelcomePage = () => {
  const [proceed, setProceed] = useState(false);
  const [checkAgreement, setCheckAgreement] = useState(false);

  const handleToggle = () => {
    const newValue = !checkAgreement;
    setCheckAgreement(newValue);
  };

  const BoxStyle = (theme: any) => ({
    root: {
      border: "1px solid #E5E5E5",
      borderRadius: "16px",
      padding: "1rem",
      textAlign: "left",
      marginTop: "2.5rem",
      width: "463.5px",
      [theme.breakpoints.down("md")]: {
        width: "auto",
        margin: "0 2vw",
        marginTop: "2.5rem",
      },
    },
  });

  const navigate = useNavigate();

  const theme = useTheme();
  const styles = BoxStyle(theme);

  return (
    <>
      <Box sx={{ padding: "3rem 0" }}>
        <Container
          maxWidth="md"
          sx={{ paddingLeft: "0.417vw", paddingRight: "0.417vw" }}
        >
          <Box
            sx={{
              border: "1px solid #E5E5E5",
              borderRadius: "16px",
              textAlign: "center",
              background: "white",
              justifyItems: "center",
              padding: { xs: "0.833vw 0", md: "2rem 0" },
              display: "grid",
              [theme.breakpoints.down("md")]: {
                borderRadius: 0,
              },
            }}
          >
            <Typography
              variant="h2"
              fontWeight="bold"
              gutterBottom
              sx={{ marginTop: { xs: "2rem" } }}
            >
              Welcome to EZIFIN R&D Loan Application
            </Typography>

            <Typography
              variant="h3"
              fontWeight={400}
              sx={{
                maxWidth: "63%",
                [theme.breakpoints.down("md")]: {
                  maxWidth: "98%",
                },
              }}
            >
              We’re here to make applying for a R&D loan simple, secure, and
              transparent. This application will guide you step-by-step so you
              always know what’s next.
            </Typography>

            {/* Box 1 */}
            <Box sx={styles.root}>
              <Typography variant="h3">What to expect</Typography>
              <Box maxWidth={"99%"}>
                <Box
                  sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
                  py={2}
                >
                  <HourGlassIcon />
                  <Typography
                    variant="h3"
                    fontWeight={400}
                    lineHeight={"normal"}
                  >
                    Application takes about 15 minutes.
                  </Typography>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
                  py={2}
                >
                  <BookmarkIcon />
                  <Typography
                    variant="h3"
                    fontWeight={400}
                    lineHeight={"normal"}
                  >
                    You can save and return anytime.
                  </Typography>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
                  py={2}
                >
                  <PadlockIcon />
                  <Typography
                    variant="h3"
                    fontWeight={400}
                    lineHeight={"normal"}
                  >
                    All information is kept confidential and secure.
                  </Typography>
                </Box>
                <Box
                  sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}
                  py={2}
                >
                  <TeamIcon />
                  <Typography
                    variant="h3"
                    fontWeight={400}
                    lineHeight={"normal"}
                  >
                    Once submitted, our team will review and get in touch
                    quickly.
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Checkbox Agreement */}
            <Box
              sx={{
                textAlign: "left",
                marginTop: "1.5rem",
                width: { xs: "100%", md: "calc(463.5px + 1rem)" },
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkAgreement}
                    sx={{ position: "relative", top: "-2px" }}
                    color="primary"
                    onClick={() => handleToggle()}
                  />
                }
                sx={{
                  gap: "0.5rem",
                  [theme.breakpoints.down("md")]: {
                    margin: 0,
                  },
                }}
                label="I have read and understood Ezifin’s privacy information
                regarding the collection, use, and disclosure of my personal and
                business information."
              />
            </Box>

            {/* Button Start */}
            <Box paddingTop={"3rem"} sx={{ marginBottom: { xs: "2rem" } }}>
              <AppPrimaryButton
                title="Get Started"
                isLoading={proceed}
                loadingText="Please wait.."
                onClick={() => {
                  if (!checkAgreement) {
                    Utils.handleMessageResponse(
                      `Please read and understood EZIFIN's privacy information to continue.`
                    );
                    return;
                  }
                  setProceed(true);
                  setTimeout(() => {
                    navigate("/rnd/intro-details");
                  }, 500);
                }}
                endIcon={<ArrowForward />}
                disabled={!checkAgreement}
              />
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default RNDWelcomePage;
